module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_rogaland_pos.28e8fcd2.svg";